<template>
  <section>
    <div class="c-modal" :style="{display: show ? 'block' : 'none', 'z-index': 200}">
      <div class="c-modal__dialog c-modal__dialog--center">
          <!-- Modal content -->
          <div class="c-modal__content">
            <div class="c-modal__title">
              {{orderType.type == 'reservation' ? 'リスト' : '商品をカート'}}に追加しました  
            </div>
            <div class="c-modal__buttons-large">
              <a v-if="orderType.type != 'reservation'" href="javascript:void(0)" @click.prevent="toShopTop" class="c-btn c-btn--center c-btn--no-arrow c-btn__red mb-8">
                他の商品を見る
              </a>
              <a v-if="orderType.type != 'reservation'" href="javascript:void(0)" @click.prevent="toShopList" class="c-btn c-btn--center c-btn--no-arrow c-btn__red mb-16">
                他のお店の商品を見る
              </a>
              <a href="javascript:void(0)" @click.prevent="toCheckout" class="c-btn c-btn--center c-btn--no-arrow">
                現在の内容で{{orderType.type == 'reservation' ? '予約' : '決済'}}する
              </a>
            </div>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import store from "../store";
export default Vue.extend({
  name: 'confirm',
  props: ['show','orderType'],
  components: {
  },
  methods: {
    toShopTop(){
      const type = this.orderType.type;//this.$route.params.type;
      const tenantId = this.orderType.tenant;
      this.$router.push(`/mobileorder/shop/${tenantId}/${type}`);
    },
    toShopList(){
      const type = this.orderType.type;//this.$route.params.type;
      this.$router.push(`/mobileorder/${type}/shop`);
    },
    toCheckout(){
      const type = this.orderType.type;
      if (type == 'reservation') {
        this.$router.push('/mobileorder/checkout');
      } else {
        this.$router.push('/mobileorder/cart')
      }
    }
  }
})
</script>